import { formatRingSize } from '../photo-upload/ringSize'

// The units the upload page's fields panel shows (ProductFields' UNITS).
const UNITS = { weight: 'g', width: 'mm', height: 'mm', length: 'in.', band_width: 'mm', center_stone: 'ct', side_stones: 'ct' }

const dollars = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

// Shopify's price ("1250.00") as the store shows it, or null.
export function formatPrice(price) {
    if (price === null || price === undefined || price === '') return null
    const amount = Number(price)
    return Number.isFinite(amount) ? dollars.format(amount) : null
}

// One field from the preview, as text: '6½', '3.8 g', 'Yellow, White', or '—'.
export function formatFieldValue({ key, value }) {
    if (value === null || value === undefined || value === '') return '—'
    if (Array.isArray(value)) return value.length ? value.join(', ') : '—'
    if (key === 'ring_size') return formatRingSize(value) || '—'
    return UNITS[key] ? `${value} ${UNITS[key]}` : String(value)
}

// 'delsonjewelry.com/products/ring-1', for the preview's address bar.
export function storeAddress({ onlineStoreUrl, handle }) {
    if (onlineStoreUrl) return onlineStoreUrl.replace(/^https?:\/\//, '')
    return handle ? `/products/${handle}` : null
}
